"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { NavigationTabs } from "@/components/common/navigationTabs";
import { TableContainer } from "@/components/common/TableContainer";
import AccountDetails from "@/components/settings/AccountDetails";
import BusinessInfo from "@/components/settings/BusinessInfo";
import Permission from "@/components/settings/Permission";
import Notifications from "@/components/settings/Notifications";

const settingsTabs = [
  { label: "Account Details", value: "account" },
  { label: "Business Info", value: "business" },
  { label: "Permission", value: "permission" },
  { label: "Notifications", value: "notifications" },
];

const SettingsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<string>(searchParams.get("tab") || "account");

  useEffect(() => {
    const requestedTab = searchParams.get("tab");
    if (requestedTab && requestedTab !== activeTab) {
      setActiveTab(requestedTab);
    }
  }, [searchParams, activeTab]);

  const updateTab = (tab: string) => {
    setActiveTab(tab);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", tab);
    setSearchParams(nextParams, { replace: true });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "account":
        return <AccountDetails />;
      case "business":
        return <BusinessInfo />;
      case "permission":
        return <Permission />;
      case "notifications":
        return <Notifications />;
      default:
        return <AccountDetails />;
    }
  };

  return (
    <div className="space-y-4">
      <TableContainer
        navigationTabs={
          <NavigationTabs
            tabs={settingsTabs.map((tab) => ({
              label: tab.label,
              onClick: () => updateTab(tab.value),
              isActive: activeTab === tab.value,
            }))}
            hasBackButton={false}
          />
        }
      >
        {renderTabContent()}
      </TableContainer>
    </div>
  );
};

export default SettingsPage;
